/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Actionconfirmmany2Inputs */

const en_actionconfirmmany2 = /** @type {(inputs: Actionconfirmmany2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`It goes to ${i?.count} favourites. One action per day.`)
};

const de_actionconfirmmany2 = /** @type {(inputs: Actionconfirmmany2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sie geht an ${i?.count} Favoriten. Pro Tag geht eine Aktion.`)
};

/**
* | output |
* | --- |
* | "It goes to {count} favourites. One action per day." |
*
* @param {Actionconfirmmany2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actionconfirmmany2 = /** @type {((inputs: Actionconfirmmany2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actionconfirmmany2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actionconfirmmany2(inputs)
	return de_actionconfirmmany2(inputs)
});
export { actionconfirmmany2 as "actionConfirmMany" }